import React from "react";
import {ThemeConfig, writeDarkSwitch} from 'bootstrap-darkmode';
import "./App.css";
import Header from './components/Header'

import Footer from './components/Footer'
import FooterRight from './components/FooterRight'
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";

import {
  getLedgerWallet,
  getPhantomWallet,
  getSlopeWallet,
  getSolflareWallet,
  getSolletExtensionWallet,
  getSolletWallet
} from "@solana/wallet-adapter-wallets";
import { clusterApiUrl } from "@solana/web3.js";

import SiteUnderMaintenance from "./components/SiteUnderMaintenance";
import UserAnalytics from "./components/UserAnalytics";
import HistoricalAnalytics from "./components/HistoricalAnalytics";
import Main from "./components/Main"
import Token from "./components/Token";
import { useAppSelector } from './hooks'
import 'bootstrap/dist/css/bootstrap.min.css';

const themeConfig = new ThemeConfig();
// place customizations here
// themeConfig.initTheme();
function App() {
  // Can be set to 'Mainnet', 'Devnet', or 'Testnet'
  const network = WalletAdapterNetwork[process.env.REACT_APP_NETWORK];
  const mode = useAppSelector(state => state.storage.mode)
  const darkmode = useAppSelector(state => state.storage.darkmode)
  // console.log(process.env.REACT_APP_NETWORK)
  // You can also provide a custom RPC endpoint
  const endpoint = React.useMemo(() => clusterApiUrl(network), [network]);
  let bgColor = 'white';
  if (darkmode) {
    document.body.classList.add('darkmode');
  } else {
    document.body.classList.remove('darkmode');
  }
  // @solana/wallet-adapter-wallets includes all the adapters but supports tree shaking --
  // Only the wallets you configure here will be compiled into your application
  const wallets = React.useMemo(
    () => [
      getPhantomWallet(),
      getSlopeWallet(),
      getSolflareWallet(),
      getLedgerWallet(),
      getSolletWallet({ network }),
      getSolletExtensionWallet({ network }),
    ],
    [network]
  );
  let rendered_comp = <Token />
  if (mode == "SOL") rendered_comp = <Main />
  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>

        <div className="App">

          <Header/>
          <UserAnalytics/>
          <HistoricalAnalytics/>
          {rendered_comp}
          <Footer/>
          <FooterRight/>

        </div>
      </WalletProvider>
    </ConnectionProvider>
  );
}

export default App;
